/*=========================================================================================
  File Name: moduleApicilMutations.js
  Description: Apicil Module Mutations
==========================================================================================*/


export default {
	SET_PROJECTID(state, payload) {
		state.projectId = payload;
	},
	SET_ETATCIVIL_FIRSTNAME(state, payload) {
		state.etatCivil.firstName = payload;
	},
	SET_ETATCIVIL_LASTNAME(state, payload) {
		state.etatCivil.lastName = payload;
	},
	SET_ETATCIVIL_BIRTHLASTNAME(state, payload) {
		state.etatCivil.birthLastName = payload;
	},
	SET_ETATCIVIL_CIVILITY(state, payload) {
		state.etatCivil.civility = payload;
	},
	SET_ETATCIVIL_DATEOFBIRTH(state, payload) {
		state.etatCivil.dateOfBirth = payload;
	},
	SET_ETATCIVIL_BIRTHCITY(state, payload) {
		state.etatCivil.birthCity = payload;
	},
	SET_ETATCIVIL_BIRTHSTATE(state, payload) {
		state.etatCivil.birthState = payload;
	},
	SET_ETATCIVIL_BIRTHDEPTNUM(state, payload) {
		state.etatCivil.birthDeptNum = payload;
	},
	SET_ETATCIVIL_BIRTHCOUNTRY(state, payload) {
		state.etatCivil.birthCountry = payload;
	},
	SET_ETATCIVIL_NATIONALITY(state, payload) {
		state.etatCivil.nationality = payload;
	},
	SET_CONTACTINFO_ADDRESS(state, payload) {
		state.contactInfo.address = payload;
	},
	SET_CONTACTINFO_ADDRESSCOMP(state, payload) {
		state.contactInfo.addressComp = payload;
	},
	SET_CONTACTINFO_ZIPCODE(state, payload) {
		state.contactInfo.zipCode = payload;
	},
	SET_CONTACTINFO_CITY(state, payload) {
		state.contactInfo.city = payload;
	},
	SET_CONTACTINFO_COUNTRY(state, payload) {
		state.contactInfo.country = payload;
	},
	SET_CONTACTINFO_EMAIL(state, payload) {
		state.contactInfo.email = payload;
	},
	SET_CONTACTINFO_MOBILETEL(state, payload) {
		state.contactInfo.mobileTel = payload;
	},
	SET_CONTACTINFO_HOMETEL(state, payload) {
		state.contactInfo.homeTel = payload;
	},
	SET_CONTACTINFO_MOBILETELFORMATTED(state, payload) {
		state.contactInfo.mobileTelFormatted = payload;
	},
	SET_CONTACTINFO_HOMETELFORMATTED(state, payload) {
		state.contactInfo.homeTelFormatted = payload;
	},
	SET_CONTACTINFO_MOBILETELINDICATIF(state, payload) {
		state.contactInfo.mobileTelIndicatif = payload;
	},
	SET_CONTACTINFO_HOMETELINDICATIF(state, payload) {
		state.contactInfo.homeTelIndicatif = payload;
	},
	SET_RESIDENCEFISCALE_ADRESSEFISCALESAME(state, payload) {
		state.residenceFiscale.adresseFiscaleSame = payload;
	},
	SET_RESIDENCEFISCALE_ISAMERICANSUBJECT(state, payload) {
		state.residenceFiscale.isAmericanSubject = payload;
	},
	SET_RESIDENCEFISCALE_ISFOREIGNSUBJECT(state, payload) {
		state.residenceFiscale.isForeignSubject = payload;
	},
	SET_RESIDENCEFISCALE_HASTIN(state, payload) {
		state.residenceFiscale.hasTin = payload;
	},
	SET_RESIDENCEFISCALE_NIF(state, payload) {
		state.residenceFiscale.nif = payload;
	},
	SET_RESIDENCEFISCALE_TIN(state, payload) {
		state.residenceFiscale.tin = payload;
	},
	SET_RESIDENCEFISCALE_NIFCOUNTRY(state, payload) {
		state.residenceFiscale.nifCountry = payload;
	},
	SET_SITUATIONFAMILIALE_FAMSITUATION(state, payload) {
		state.situationFamiliale.famSituation = payload;
	},
	SET_SITUATIONFAMILIALE_REGIMEMATRIMONIAL(state, payload) {
		state.situationFamiliale.regimeMatrimonial = payload;
	},
	SET_SITUATIONFAMILIALE_PERSONNEACHARGE(state, payload) {
		state.situationFamiliale.personneACharge = payload;
	},
	SET_SITUATIONFAMILIALE_HASREGIMEMATRIMONIAL(state, payload) {
		state.situationFamiliale.hasRegimeMatrimonial = payload;
	},
	SET_SITUATIONFAMILIALE_HASCONJOINT(state, payload) {
		state.situationFamiliale.hasConjoint = payload;
	},
	SET_CONJOINT_ETATCIVIL_FIRSTNAME(state, payload) {
		state.situationFamiliale.conjointEtatCivil.firstName = payload;
	},
	SET_CONJOINT_ETATCIVIL_LASTNAME(state, payload) {
		state.situationFamiliale.conjointEtatCivil.lastName = payload;
	},
	SET_CONJOINT_ETATCIVIL_BIRTHLASTNAME(state, payload) {
		state.situationFamiliale.conjointEtatCivil.birthLastName = payload;
	},
	SET_CONJOINT_ETATCIVIL_CIVILITY(state, payload) {
		state.situationFamiliale.conjointEtatCivil.civility = payload;
	},
	SET_CONJOINT_ETATCIVIL_DATEOFBIRTH(state, payload) {
		state.situationFamiliale.conjointEtatCivil.dateOfBirth = payload;
	},
	SET_CONJOINT_ETATCIVIL_BIRTHCITY(state, payload) {
		state.situationFamiliale.conjointEtatCivil.birthCity = payload;
	},
	SET_CONJOINT_ETATCIVIL_BIRTHSTATE(state, payload) {
		state.situationFamiliale.conjointEtatCivil.birthState = payload;
	},
	SET_CONJOINT_ETATCIVIL_BIRTHDEPTNUM(state, payload) {
		state.situationFamiliale.conjointEtatCivil.birthDeptNum = payload;
	},
	SET_CONJOINT_ETATCIVIL_BIRTHCOUNTRY(state, payload) {
		state.situationFamiliale.conjointEtatCivil.birthCountry = payload;
	},
	SET_CONJOINT_ETATCIVIL_NATIONALITY(state, payload) {
		state.situationFamiliale.conjointEtatCivil.nationality = payload;
	},
	SET_REVENUES(state, payload) {
		state.revenues = payload;
	},
	SET_PRTIMOINE(state, payload) {
		state.patrimoine = payload;
	},
	ADD_TO_REVENUES(state, payload) {
		state.revenues.push(payload);
	},
	ADD_TO_PRTIMOINE(state, payload) {
		state.patrimoine.push(payload);
	},
	SET_USERCOMMENTS(state, payload) {
		state.userComments = payload;
	},
	SET_HASCOMMENTS(state, payload) {
		state.hasComments = payload;
	},
	REMOVE_FROMREVENUES(state, payload) {
		state.revenues.splice(payload, 1);
	},
	REMOVE_FROMPATRIMOINE(state, payload) {
		state.patrimoine.splice(payload, 1);
	},
	SET_PROSITUATION(state, payload) {
		state.situationProfessionnelle.proSituation = payload;
	},
	SET_CONJOINT_PROSITUATION(state, payload) {
		state.situationProfessionnelleConjoint.proSituation = payload;
	},
	SET_ISNONSALARIE(state, payload) {
		state.situationProfessionnelle.isNonSalarie = payload;
	},
	SET_CONJOINT_ISNONSALARIE(state, payload) {
		state.situationProfessionnelleConjoint.isNonSalarie = payload;
	},
	SET_ISPPE(state, payload) {
		state.situationProfessionnelle.isPPE = payload;
	},
	SET_CONJOINT_ISPPE(state, payload) {
		state.situationProfessionnelleConjoint.isPPE = payload;
	},
	SET_ISRELATEDTOPPE(state, payload) {
		state.situationProfessionnelle.isRelatedToPPE = payload;
	},
	SET_CONJOINT_ISRELATEDTOPPE(state, payload) {
		state.situationProfessionnelleConjoint.isRelatedToPPE = payload;
	},
	SET_PROACTUELLE(state, payload) {
		state.situationProfessionnelle.proActuelle = payload;
	},
	SET_CONJOINT_PROACTUELLE(state, payload) {
		state.situationProfessionnelleConjoint.proActuelle = payload;
	},
	SET_COMPANYNAME(state, payload) {
		state.situationProfessionnelle.companyName = payload;
	},
	SET_CONJOINT_COMPANYNAME(state, payload) {
		state.situationProfessionnelleConjoint.companyName = payload;
	},
	SET_SOCIOPROCAT(state, payload) {
		state.situationProfessionnelle.socioProCat = payload;
	},
	SET_CONJOINT_SOCIOPROCAT(state, payload) {
		state.situationProfessionnelleConjoint.socioProCat = payload;
	},
	SET_ACTIVITYSECTOR(state, payload) {
		state.situationProfessionnelle.activitySector = payload;
	},
	SET_CONJOINT_ACTIVITYSECTOR(state, payload) {
		state.situationProfessionnelleConjoint.activitySector = payload;
	},
	SET_PPEFONCTION(state, payload) {
		state.situationProfessionnelle.ppeFonction = payload;
	},
	SET_CONJOINT_PPEFONCTION(state, payload) {
		state.situationProfessionnelleConjoint.ppeFonction = payload;
	},
	SET_PPECOUNTRY(state, payload) {
		state.situationProfessionnelle.ppeCountry = payload;
	},
	SET_CONJOINT_PPECOUNTRY(state, payload) {
		state.situationProfessionnelleConjoint.ppeCountry = payload;
	},
	SET_PPECOUNTRYVAL(state, payload) {
		state.situationProfessionnelle.ppeCountryVal = payload;
	},
	SET_CONJOINT_PPECOUNTRYVAL(state, payload) {
		state.situationProfessionnelleConjoint.ppeCountryVal = payload;
	},
	SET_RELATEDPPECOUNTRY(state, payload) {
		state.situationProfessionnelle.relatedPpeCountry = payload;
	},
	SET_CONJOINT_RELATEDPPECOUNTRY(state, payload) {
		state.situationProfessionnelleConjoint.relatedPpeCountry = payload;
	},
	SET_RELATEDPPECOUNTRYVAL(state, payload) {
		state.situationProfessionnelle.relatedPpeCountryVal = payload;
	},
	SET_CONJOINT_RELATEDPPECOUNTRYVAL(state, payload) {
		state.situationProfessionnelleConjoint.relatedPpeCountryVal = payload;
	},
	SET_PPERELATION(state, payload) {
		state.situationProfessionnelle.ppeRelation = payload;
	},
	SET_CONJOINT_PPERELATION(state, payload) {
		state.situationProfessionnelleConjoint.ppeRelation = payload;
	},
	SET_RELATEDPPEFONCTION(state, payload) {
		state.situationProfessionnelle.relatedPpeFonction = payload;
	},
	SET_CONJOINT_RELATEDPPEFONCTION(state, payload) {
		state.situationProfessionnelleConjoint.relatedPpeFonction = payload;
	},
	SET_PPELASTNAME(state, payload) {
		state.situationProfessionnelle.ppeLastName = payload;
	},
	SET_CONJOINT_PPELASTNAME(state, payload) {
		state.situationProfessionnelleConjoint.ppeLastName = payload;
	},
	SET_PPEFIRSTNAME(state, payload) {
		state.situationProfessionnelle.ppeFirstName = payload;
	},
	SET_CONJOINT_PPEFIRSTNAME(state, payload) {
		state.situationProfessionnelleConjoint.ppeFirstName = payload;
	},
	SET_STEP1_ISVALID(state, payload) {
		state.step1IsValid = payload;
	},
	SET_STEP(state, payload) {
		state.step = payload;
	},
	SET_RESIDENCEFISCALE_CONTACTINFO_ADDRESS(state, payload) {
		state.residenceFiscale.contactInfo.address = payload;
	},
	SET_RESIDENCEFISCALE_CONTACTINFO_ADDRESSCOMP(state, payload) {
		state.residenceFiscale.contactInfo.addressComp = payload;
	},
	SET_RESIDENCEFISCALE_CONTACTINFO_ZIPCODE(state, payload) {
		state.residenceFiscale.contactInfo.zipCode = payload;
	},
	SET_RESIDENCEFISCALE_CONTACTINFO_CITY(state, payload) {
		state.residenceFiscale.contactInfo.city = payload;
	},
	SET_RESIDENCEFISCALE_CONTACTINFO_COUNTRY(state, payload) {
		state.residenceFiscale.contactInfo.country = payload;
	},
	SET_SELECTEDPRODUCT(state, payload) {
		state.selectedProduct = payload;
	},
	SET_SELECTEDMODEGESTION(state, payload) {
		state.selectedModeGestion = payload;
	},
	SET_SELECTEDORIENTATIONGESTION(state, payload) {
		state.selectedOrientationGestion = payload;
	},
	SET_SELECTEDSOCIETEGESTION(state, payload) {
		state.selectedSocieteGestion = payload;
	},
	SET_ISSPECIFIQUE(state, payload) {
		state.isSpecifique = payload;
	},
	SET_ISADHESIONVICTORIA(state, payload) {
		state.isAdhesionVictoria = payload;
	},
	SET_ISEPARGNEHANDICAP(state, payload) {
		state.isEpargneHandicap = payload;
	},
	SET_ISCOSOUSCRIPTIONDEMENBREE(state, payload) {
		state.isCoSouscriptionDemenbree = payload;
	},
	SET_ISSOUSCRIPTIONMAJEURSOUSTUTELLE(state, payload) {
		state.isSouscriptionMajeurSousTutelle = payload;
	},
	SET_ISSOUSCRIPTIONMAJEURSOUSCURATELLE(state, payload) {
		state.isSouscriptionMajeurSousCuratelle = payload;
	},
	SET_ISPACTEADJOINTADONMANUEL(state, payload) {
		state.isPacteAdjointADonManuel = payload;
	},
	SET_ISCOSOUSCRIPTION(state, payload) {
		state.isCoSouscription = payload;
	},
	SET_ISCONTRATENFONDSPROPRES(state, payload) {
		state.isContratEnFondsPropres = payload;
	},
	SET_ISSIGNATUREPAPIER(state, payload) {
		state.isSignaturePapier = payload;
	},
	SET_ISSIGNATUREELECTRONIQUE(state, payload) {
		state.isSignatureElectronique = payload;
	},
	SET_OBJECTIFINVEST(state, payload) {
		state.objectifInvest = payload;
	},
	SET_DUREEINVEST(state, payload) {
		state.dureeInvest = payload;
	},
	SET_HASGARANTIEPLANCHER(state, payload) {
		state.hasGarantiePlancher = payload;
	},
	SET_DUREEINVESTVAL(state, payload) {
		state.dureeInvestVal = payload;
	},
	SET_HASVERSEMENTPROGRAMME(state, payload) {
		state.hasVersementProgramme = payload;
	},
	SET_VERSEMENTPROGRAMME_PERIODICITEVERSEMENT(state, payload) {
		state.VersementProgramme.periodiciteVersement = payload;
	},
	SET_VERSEMENTPROGRAMME_MONTANTVERSEMENT(state, payload) {
		state.VersementProgramme.montantVersement = payload;
	},
	SET_MONTANTVERSEMENTINITIAL(state, payload) {
		state.montantVersementInitial = payload;
	},
	SET_PAYMENTFROMSUBSCRIBER(state, payload) {
		state.paymentFromSubscriber = payload;
	},
	SET_PAYEURCONTACTINFO_FIRSTNAME(state, payload) {
		state.payeurContactInfo.firstName = payload;
	},
	SET_PAYEURCONTACTINFO_LASTNAME(state, payload) {
		state.payeurContactInfo.lastName = payload;
	},
	SET_PAYEURCONTACTINFO_LIENPARENTE(state, payload) {
		state.payeurContactInfo.lienParente = payload;
	},
	SET_PAYEURCONTACTINFO_DATEOFBIRTH(state, payload) {
		state.payeurContactInfo.dateOfBirth = payload;
	},
	SET_PAYEURCONTACTINFO_BIRTHCITY(state, payload) {
		state.payeurContactInfo.birthCity = payload;
	},
	SET_MODEPAIEMENT(state, payload) {
		state.modePaiement = payload;
	},
	SET_DONNEESBANCAIRES_TITULAIRE(state, payload) {
		state.donneesBancaires.titulaire = payload;
	},
	SET_DONNEESBANCAIRES_IBAN(state, payload) {
		state.donneesBancaires.IBAN = payload;
	},
	SET_DONNEESBANCAIRES_BIC(state, payload) {
		state.donneesBancaires.BIC = payload;
	},
	SET_ORIGINEFONDS_TRANSFERTPLACEMENT(state, payload) {
		state.origineFonds.transfertPlacement = payload;
	},
	SET_ORIGINEFONDS_CESSIONACTIFSPRO(state, payload) {
		state.origineFonds.cessionActifsPro = payload;
	},
	SET_ORIGINEFONDS_VENTEIMMO(state, payload) {
		state.origineFonds.venteImmo = payload;
	},
	SET_ORIGINEFONDS_VENTEBIENSMOBILIERS(state, payload) {
		state.origineFonds.venteBiensMobiliers = payload;
	},
	SET_ORIGINEFONDS_SUCCESSIONOUDONATION(state, payload) {
		state.origineFonds.successionOuDonation = payload;
	},
	SET_ORIGINEFONDS_REVENUSPRO(state, payload) {
		state.origineFonds.revenusPro = payload;
	},
	SET_ORIGINEFONDS_AUTRESORIGINES(state, payload) {
		state.origineFonds.autresOrigines = payload;
	},
	SET_ORIGINEFONDS_COMMENTAIREAUTRES(state, payload) {
		state.origineFonds.commentaireAutres = payload;
	},
	SET_CLAUSEBENEFICIAIRE(state, payload) {
		state.clauseBeneficiaire = payload;
	},
	SET_NOTAIRECONTACTINFO_FIRSTNAME(state, payload) {
		state.notaireContactInfo.firstName = payload;
	},
	SET_NOTAIRECONTACTINFO_LASTNAME(state, payload) {
		state.notaireContactInfo.lastName = payload;
	},
	SET_NOTAIRECONTACTINFO_ZIPCODE(state, payload) {
		state.notaireContactInfo.zipCode = payload;
	},
	SET_NOTAIRECONTACTINFO_CITY(state, payload) {
		state.notaireContactInfo.city = payload;
	},
	SET_VERSEMENTINITIALMINIMUM(state, payload) {
		state.versementInitialMinimum = payload;
	},
	SET_RESTEAJUSTIFIE(state, payload) {
		state.resteAJustifie = payload;
	},
	SET_PROJECT_DATA(state, payload) {
		state.projectId = payload.projectId;
		state.step = payload.step;
		state.etatCivil = payload.etatCivil;
		state.contactInfo = payload.contactInfo;
		state.residenceFiscale = payload.residenceFiscale;
		state.situationFamiliale = payload.situationFamiliale;
		state.situationProfessionnelle = payload.situationProfessionnelle;
		state.situationProfessionnelleConjoint = payload.situationProfessionnelleConjoint;
		if (payload.revenues)
			state.revenues = payload.revenues;
		else {
			state.revenues = [];
		}
		if (payload.patrimoine)
			state.patrimoine = payload.patrimoine;
		else {
			state.patrimoine = [];
		}
		state.selectedProduct = payload.selectedProduct;
		if (state.selectedProduct && state.selectedProduct != "IL" && !state.selectedModeGestion) {
			state.selectedModeGestion = "PILO";
		} else {
			state.selectedModeGestion = payload.selectedModeGestion;
		}
		state.selectedOrientationGestion = payload.selectedOrientationGestion;
		state.selectedSocieteGestion = payload.selectedSocieteGestion;

		state.isSignaturePapier = payload.isSignaturePapier;
		state.isSignatureElectronique = payload.isSignatureElectronique;

		state.isSpecifique = payload.isSpecifique;
		state.isEpargneHandicap = payload.isEpargneHandicap;
		state.isCoSouscriptionDemenbree = payload.isCoSouscriptionDemenbree;
		state.isSouscriptionMajeurSousTutelle = payload.isSouscriptionMajeurSousTutelle;
		state.isPacteAdjointADonManuel = payload.isPacteAdjointADonManuel;
		state.isSouscriptionMajeurSousCuratelle = payload.isSouscriptionMajeurSousCuratelle;
		state.isCoSouscription = payload.isCoSouscription;
		state.isContratEnFondsPropres = payload.isContratEnFondsPropres;

		state.objectifInvest = payload.objectifInvest;
		state.dureeInvest = payload.dureeInvest;
		state.dureeInvestVal = payload.dureeInvestVal;
		state.hasGarantiePlancher = payload.hasGarantiePlancher;
		state.isAdhesionVictoria = payload.isAdhesionVictoria;

		state.hasVersementProgramme = payload.hasVersementProgramme;
		if (payload.versementProgramme)
			state.VersementProgramme = payload.versementProgramme;
		else {
			state.VersementProgramme = {
				periodiciteVersement: "",
				montantVersement: 0
			};
		}
		state.montantVersementInitial = payload.montantVersementInitial;
		if (payload.payeurContactInfo)
			state.payeurContactInfo = payload.payeurContactInfo;
		else {
			state.payeurContactInfo = {
				firstName: "",
				lastName: "",
				lienParente: "",
				dateOfBirth: "",
				birthCity: "",
			};
		}
		if (payload.donneesBancaires)
			state.donneesBancaires = {
				titulaire: payload.donneesBancaires.titulaire,
				IBAN: payload.donneesBancaires.iban,
				BIC: payload.donneesBancaires.bic
			};
		else {
			state.donneesBancaires = {
				titulaire: "",
				IBAN: "",
				BIC: ""
			};
		}
		if (payload.origineFonds)
			state.origineFonds = payload.origineFonds;
		else {
			state.origineFonds = {
				transfertPlacement: 0,
				cessionActifsPro: 0,
				venteImmo: 0,
				venteBiensMobiliers: 0,
				successionOuDonation: 0,
				revenusPro: 0,
				autresOrigines: 0,
				commentaireAutres: ""
			};
		}
		state.modePaiement = payload.modePaiement;

		state.clauseBeneficiaire = payload.clauseBeneficiaire;
		state.notaireContactInfo = payload.notaireContactInfo;
		if (!payload.notaireContactInfo) {
			state.notaireContactInfo = {
				firstName: "",
				lastName: "",
				zipCode: "",
				city: ""
			};
		}
	},
};